import xhr from '../utils/xhr';

let api = {
    get: (filters = { query: null }, sorting = { sortBy: "nameSort", direction: "asc" }, pagination = { pageSize: -1, pageNumber: -1 }) => {
        let searchFilter = filters.query !== null && filters.query.length ? `&nameFilter=${encodeURIComponent(filters.query)}` : ""
        return xhr.get({
            url: `/api/alerts/?pageNumber=${pagination.pageNumber}&pageSize=${pagination.pageSize}&sortBy=${sorting.sortBy}&direction=${sorting.direction}${searchFilter}`
        });
    },

    count: (filters = { query: null }) => {
        let searchFilter = filters.query !== null && filters.query.length ? `&nameFilter=${encodeURIComponent(filters.query)}` : ""
        return xhr.get({
            url: `/api/alerts/count?sortBy=name&direction=desc${searchFilter}`
        });
    },
    deleteAlerts: (alertIds) => {
        return xhr.delete({
            url: "/api/alerts/",
            data: alertIds
        })
    },
    activateAlerts: (alertIds) => {
        return xhr.post({
            url: "/api/alerts/activate",
            data: alertIds
        })
    },
    pauseAlerts: (alertIds) => {
        return xhr.post({
            url: "/api/alerts/deactivate",
            data: alertIds
        })
    }
}

export default api;


// WEBPACK FOOTER //
// ./src/scripts/api/EmailAlerts.api.js